import React from 'react';

import dayjs from '~/timeInit';

import { DesktopDateTimePicker } from '@mui/x-date-pickers-pro';

import { SYDNEY_TIMEZONE } from '~/services/TimeService';

interface Props {
  label: string;
  value: string | null;
  onChange: (value: string | null) => void;
  error?: string;
  required?: boolean;
  helperText?: string;
}

/** A campaign schedule date and time, entered in Sydney time and stored as an ISO timestamp. */
export default function NativeTourScheduleDateField({
  label,
  value,
  onChange,
  error,
  required = true,
  helperText,
}: Props) {
  return (
    <DesktopDateTimePicker
      label={label}
      timezone={SYDNEY_TIMEZONE}
      ampm={false}
      value={value ? dayjs(value) : null}
      onChange={(next) => onChange(next?.isValid() ? next.toISOString() : null)}
      slotProps={{
        field: { clearable: !required },
        textField: {
          fullWidth: true,
          required,
          error: !!error,
          helperText: error ?? helperText,
        },
      }}
    />
  );
}
